import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "upload-file-item" }
const _hoisted_2 = { class: "upload-file-item__info" }
const _hoisted_3 = { class: "upload-file-item__header" }
const _hoisted_4 = { class: "upload-file-item__actions" }
const _hoisted_5 = {
  key: 0,
  class: "upload-file-item__action upload-file-item__action--success",
  title: "Успешно загружено"
}
const _hoisted_6 = {
  key: 0,
  class: "upload-file-item__size"
}
const _hoisted_7 = {
  key: 1,
  class: "upload-file-item__error"
}

import IconCheck from "@/assets/icons/IconCheck.vue";
import IconRefresh from "@/assets/icons/IconRefresh.vue";
import IconTrash from "@/assets/icons/IconTrash.vue";
import IconCross from "@/assets/icons/IconCross.vue";
import ProgressBar from "@/components/modules/FileUploadModal/ProgressBar.vue";
import {FileStatus} from "@/types/files";

interface Props {
  fileName: string;
  fileSize: number;
  status?: FileStatus;
  error?: null | string;
  progress?: number;
  isFileUploadingComplete?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UploadFileItem',
  props: {
    fileName: {},
    fileSize: {},
    status: { default: "pending" },
    error: { default: null },
    progress: { default: 0 },
    isFileUploadingComplete: { type: Boolean, default: false }
  },
  emits: ["retry", "delete", "cancel"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return bytes + " Б";
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + " КБ";
  return (bytes / (1024 * 1024)).toFixed(2) + " МБ";
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          class: _normalizeClass([{'upload-file-item__name--error': __props.error || __props.status === 'validation_error'}, "upload-file-item__name"])
        }, _toDisplayString(__props.fileName), 3),
        _createElementVNode("div", _hoisted_4, [
          (__props.status === 'validated' && __props.isFileUploadingComplete)
            ? (_openBlock(), _createElementBlock("button", _hoisted_5, [
                _createVNode(IconCheck)
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("button", {
                  class: "upload-file-item__action",
                  title: "Повторить загрузку",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('retry')))
                }, [
                  _createVNode(IconRefresh)
                ]),
                _createElementVNode("button", {
                  class: "upload-file-item__action",
                  title: "Удалить файл",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('delete')))
                }, [
                  _createVNode(IconTrash)
                ]),
                (__props.status === 'uploading')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "upload-file-item__action",
                      title: "Отменить загрузку",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('cancel')))
                    }, [
                      _createVNode(IconCross)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
        ])
      ]),
      (!__props.error && __props.status === 'validated')
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(formatFileSize(__props.fileSize)), 1))
        : (__props.error || __props.status === 'validation_error')
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Ошибка загрузки"))
          : _createCommentVNode("", true)
    ]),
    (__props.status === 'uploading' || __props.isFileUploadingComplete)
      ? (_openBlock(), _createBlock(ProgressBar, {
          key: 0,
          progress: __props.progress,
          "is-uploading": __props.status === 'uploading'
        }, null, 8, ["progress", "is-uploading"]))
      : _createCommentVNode("", true)
  ]))
}
}

})